import { useMemo } from 'react';
import { useParams } from 'react-router-dom';
import { ProfileHeader } from './components/ProfileHeader';
import { ProfileTabs } from './components/ProfileTabs';
import { useAuth } from '@/shared/state/auth-context';
import { useStore } from '@/shared/state/store';
import {
  getUserByUsername,
  getPostsByAuthor,
  getReelsByAuthor,
  getPostById,
} from '@/shared/data';
import { NotFoundRedirect } from '@/shared/utils/NotFoundRedirect';

export function Profile() {
  const { username = '' } = useParams<{ username: string }>();
  const user = getUserByUsername(username);
  const { currentUser } = useAuth();
  const savedSet = useStore((s) => s.savedPostIds);
  const savedPosts = useMemo(
    () =>
      Array.from(savedSet)
        .map(getPostById)
        .filter((p): p is NonNullable<typeof p> => Boolean(p)),
    [savedSet],
  );

  if (!user) return <NotFoundRedirect />;
  const isMe = currentUser?.id === user.id || username === 'you';

  return (
    <div>
      <ProfileHeader user={user} />
      <ProfileTabs
        user={user}
        posts={getPostsByAuthor(user.id)}
        reels={getReelsByAuthor(user.id)}
        saved={savedPosts}
        isMe={isMe}
      />
    </div>
  );
}
